import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-150c90c8")

_pushScopeId("data-v-150c90c8")
const _hoisted_1 = {
  class: "ui__ecu_main",
  id: "EcuInfo"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "ui__ecu_title" }, [
  /*#__PURE__*/_createTextVNode("ECU检测 "),
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createTextVNode("查看详情"),
    /*#__PURE__*/_createVNode("i")
  ])
], -1)
const _hoisted_3 = {
  key: 1,
  class: "ui__ecu_body"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "ui__ecu_title" }, [
  /*#__PURE__*/_createTextVNode("ECU检测 "),
  /*#__PURE__*/_createVNode("span", null, "ECU查询失败")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "ui__line_main" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    (Object.keys(_ctx.state.ecuInfo).length !== 0)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "ui__ecu_body",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toView && _ctx.toView(...args)))
        }, [
          _hoisted_2
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_3, [
          _hoisted_4
        ])),
    _hoisted_5
  ], 512)), [
    [_vShow, _ctx.state.reportLevel === 1 || _ctx.state.reportLevel === 2 || _ctx.state.reportLevel === 16]
  ])
})